import React from 'react';

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Button } from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid';

interface DialogConfirmProps {
  open: boolean;
  title: string;
  contentText: string;
  confirmButtonText: string;
  onClose: () => void;
  onConfirm: () => void;
}

const DialogConfirm: React.FC<DialogConfirmProps> = ({
  open,
  title,
  contentText,
  confirmButtonText,
  onClose,
  onConfirm,
}) => {
  const handleClose = (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason === 'backdropClick') {
      // Prevent closing when clicking on the backdrop
      return;
    }
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose} 
      aria-labelledby="dialog-confirm-title" 
      fullWidth 
      maxWidth="sm"
      >
      <DialogTitle id="dialog-confirm-title" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {title}
        <IconButton aria-label="close" onClick={onClose} size="small">
          <GridCloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>{contentText}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button 
          variant="contained" 
          color="secondary"
          onClick={onConfirm} >
          { confirmButtonText }
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogConfirm;
